
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thriftyadvice",
      function () {
        return require("private-next-pages/thriftyadvice/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thriftyadvice"])
      });
    }
  